// app/assets/javascripts/lead_charts.js - VERSÃO PARA LEADS
import axios from "axios";
import {
  enableSelect,
  disableSelect,
  clearSelectElTarget,
  clearEl,
} from "./attendance_concerns";

// Cache para armazenar dados já carregados
const dataCache = {
  groups: new Map(),
  dealers: new Map(),
};

// Debounce para evitar múltiplas requisições
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const fnMain = () => {
  const companyEl = document.querySelector("#lead_charts_group_company_id_eq");
  const groupEl = document.querySelector("#lead_charts_dealer_group_id_eq");
  const dealerEl = document.querySelector("#lead_charts_dealer_id_eq");

  if (companyEl || groupEl || dealerEl) {
    const BASE_URL = "searches";

    // Flag para evitar loops de atualização
    let isUpdating = false;

    const init = () => {
      // Inicialização mais eficiente
      const urlParams = new URLSearchParams(window.location.search);
      const companyId = urlParams.get('q[group_company_id_eq]');
      const groupId = urlParams.get('q[dealer_group_id_eq]');
      const dealerId = urlParams.get('q[dealer_id_eq]');

      // Se há parâmetros na URL, carrega os dados em paralelo quando possível
      if (companyId) {
        loadInitialDataOptimized(companyId, groupId, dealerId);
      } else {
        // Estado inicial
        disableSelect(groupEl);
        disableSelect(dealerEl);
        clearSelectElTarget(groupEl, "Selecione primeiro o Grupo");
        clearSelectElTarget(dealerEl, "Selecione primeiro a Empresa");
      }

      // Adiciona handlers com debounce
      if (companyEl) companyEl.addEventListener("change", debounce(handleCompanyChange, 300));
      if (groupEl) groupEl.addEventListener("change", debounce(handleGroupChange, 300));
    };

    const loadInitialDataOptimized = async (companyId, groupId, dealerId) => {
      try {
        // Mostra loading
        if (groupEl) showLoading(groupEl, "Carregando empresas...");

        // Carrega grupos
        const groups = await fetchGroups(companyId);

        if (groups.length > 0) {
          if (groupEl) updateSelectOptions(groupEl, groups, groupId, "Todas");

          // Se tem grupo selecionado, carrega dealers
          if (groupId) {
            if (dealerEl) showLoading(dealerEl, "Carregando revendas...");
            const dealers = await fetchDealers(groupId);
            if (dealerEl) updateSelectOptions(dealerEl, dealers, dealerId, "Todas");
          }
        }
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
        handleLoadError(groupEl, "Erro ao carregar empresas");
      }
    };

    const fetchGroups = async (companyId) => {
      // Verifica cache primeiro
      if (dataCache.groups.has(companyId)) {
        return dataCache.groups.get(companyId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/groups`, {
          params: { 'q[company_id_eq]': companyId },
          timeout: 5000 // Timeout de 5 segundos
        });

        const groups = response.data.groups || [];
        dataCache.groups.set(companyId, groups);
        return groups;
      } catch (error) {
        console.error('Erro ao buscar grupos:', error);
        throw error;
      }
    };

    const fetchDealers = async (groupId) => {
      // Verifica cache primeiro
      if (dataCache.dealers.has(groupId)) {
        return dataCache.dealers.get(groupId);
      }

      try {
        const response = await axios.get(`${BASE_URL}/dealers`, {
          params: { 'q[group_id_eq]': groupId },
          timeout: 5000
        });

        const dealers = response.data.dealers || [];
        dataCache.dealers.set(groupId, dealers);
        return dealers;
      } catch (error) {
        console.error('Erro ao buscar revendas:', error);
        throw error;
      }
    };

    const updateSelectOptions = (selectEl, items, selectedId, defaultText) => {
      if (!selectEl || isUpdating) return;

      isUpdating = true;

      // Constrói todas as options de uma vez (muito mais rápido)
      const options = [`<option value="">${defaultText}</option>`];

      items.forEach(item => {
        const selected = item.id == selectedId ? 'selected' : '';
        options.push(`<option value="${item.id}" ${selected}>${item.name}</option>`);
      });

      // Atualiza o DOM uma única vez
      selectEl.innerHTML = options.join('');
      enableSelect(selectEl);

      // Atualiza selectpicker usando a forma correta
      refreshSelectPicker(selectEl);
      isUpdating = false;
    };

    // Função auxiliar para refresh correto do selectpicker
    const refreshSelectPicker = (selectEl) => {
      if (!selectEl) return;

      if (window.jQuery && $(selectEl).data('selectpicker')) {
        setTimeout(() => $(selectEl).selectpicker('refresh'), 0);
      }
    };

    const showLoading = (selectEl, message) => {
      if (!selectEl) return;
      selectEl.innerHTML = `<option value="">${message}</option>`;
      disableSelect(selectEl);
    };

    const handleLoadError = (selectEl, message) => {
      if (!selectEl) return;
      clearSelectElTarget(selectEl, message);
      disableSelect(selectEl);
    };

    const handleCompanyChange = async function () {
      const companyId = companyEl.value;

      // Limpa os selects dependentes
      if (groupEl) { clearSelectElTarget(groupEl, "Selecione a Empresa"); disableSelect(groupEl); }
      if (dealerEl) { clearSelectElTarget(dealerEl, "Selecione a Revenda"); disableSelect(dealerEl); }

      if (!companyId) {
        return;
      }

      try {
        if (groupEl) showLoading(groupEl, "Carregando empresas...");
        const groups = await fetchGroups(companyId);

        if (groupEl) {
          if (groups.length > 0) updateSelectOptions(groupEl, groups, null, "Todas");
          else handleLoadError(groupEl, "Nenhuma empresa encontrada");
        }
      } catch (error) {
        if (groupEl) handleLoadError(groupEl, "Erro ao carregar empresas");
      }
    };

    const handleGroupChange = async function () {
      const groupId = groupEl.value;

      // Limpa select dependente
      if (dealerEl) { clearSelectElTarget(dealerEl, "Selecione a Revenda"); disableSelect(dealerEl); }

      if (!groupId) {
        return;
      }

      try {
        if (dealerEl) showLoading(dealerEl, "Carregando revendas...");
        const dealers = await fetchDealers(groupId);

        if (dealerEl) {
          if (dealers.length > 0) updateSelectOptions(dealerEl, dealers, null, "Todas");
          else handleLoadError(dealerEl, "Nenhuma revenda encontrada");
        }
      } catch (error) {
        if (dealerEl) handleLoadError(dealerEl, "Erro ao carregar revendas");
      }
    };

    // Limpa cache quando necessário (ex: a cada 5 minutos)
    setInterval(() => {
      dataCache.groups.clear();
      dataCache.dealers.clear();
    }, 300000); // 5 minutos

    init();
  }
};

// Inicialização otimizada
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fnMain);

  // Animação dos cards de estatísticas (se houver)
  document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('[data-card-id]');

    // Observer para animar quando entra na viewport
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const card = entry.target;
          animateCard(card);
          observer.unobserve(card);
        }
      });
    }, observerOptions);

    cards.forEach(card => {
      observer.observe(card);
    });

    function animateCard(card) {
      const targetValue = parseInt(card.dataset.cardValue) || 0;
      const targetPercent = parseInt(card.dataset.cardPercent) || 0;

      // Anima número principal
      const valueEl = card.querySelector('.value-number');
      if (valueEl) {
        animateNumber(valueEl, 0, targetValue, 800);
      }

      // Anima porcentagem
      const percentEl = card.querySelector('.percent-value');
      if (percentEl) {
        animateNumber(percentEl, 0, targetPercent, 800, '%');
      }

      // Anima barra de progresso
      const progressBar = card.querySelector('.progress-bar');
      if (progressBar) {
        setTimeout(() => {
          progressBar.style.width = targetPercent + '%';
        }, 100);
      }
    }

    function animateNumber(element, start, end, duration, suffix = '') {
      const startTime = performance.now();

      function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Easing
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.floor(start + (end - start) * easeProgress);

        element.textContent = currentValue.toLocaleString('pt-BR') + suffix;

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          element.textContent = end.toLocaleString('pt-BR') + suffix;
        }
      }

      requestAnimationFrame(update);
    }
  });
} else {
  fnMain();
}